import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  gradientDivider: {
    backgroundImage:
      'linear-gradient(to right, #8b84d7 0%, #5bc2e7 51%, #80e0a7 100%)',
    height: '2px',
    marginBottom: '32px',
    marginTop: '29px',
    width: '100%'
  }
});

const GradientDivider = ({ className, style }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.gradientDivider} ${className}`} style={style} />
  );
};

export default GradientDivider;
